
function GalleryInfo({ title, length }) {
  return (
    <div className="flex mb-5 items-center">
      <h1 className="text-lg	font-semibold">{title}</h1>
      <p className="font-normal flex items-center ml-6	text-sm	text-[#747474]">
        <img src="/dot.svg" className="mr-1.5 ml-7" alt="dot" />
        {length} images
      </p>
    </div>
  );
}

export default GalleryInfo;
